import React from 'react';
import { Clapperboard } from 'lucide-react';
import { useSidebar } from './ui/sidebar';

type ScriptModeFloatingButtonProps = {
  isVisible: boolean;
  onExit: () => void;
  isMobile: boolean;
  isFocusMode: boolean;
  t: (key: string) => string;
};

export const ScriptModeFloatingButton: React.FC<ScriptModeFloatingButtonProps> = ({
  isVisible,
  onExit,
  isMobile,
  isFocusMode,
  t,
}) => {
  let sidebar;
  try {
    sidebar = useSidebar();
  } catch {
    sidebar = null;
  }
  const leftOffset = isMobile ? '1.3rem' : (isFocusMode ? '1rem' : (sidebar?.open ? '17rem' : '4rem'));

  if (!isVisible) {
    return null;
  }

  return (
    <button
      type="button"
      className="floating-editor-control"
      onClick={onExit}
      style={{
        position: 'fixed',
        bottom: '1rem',
        left: leftOffset,
        zIndex: 50,
        width: isFocusMode ? '40px' : undefined,
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        gap: isFocusMode ? 0 : '0.5rem',
        justifyContent: 'center',
        cursor: 'pointer',
        border: 'none',
        padding: isFocusMode ? 0 : '0 0.75rem',
        color: 'var(--muted-foreground)',
        transition: 'background-color 0.2s, box-shadow 0.2s',
        fontSize: '0.8125rem',
      }}
      aria-label={t('exit_script_mode') || 'Exit script mode'}
      title={t('exit_script_mode') || 'Exit script mode'}
    >
      <Clapperboard className={isFocusMode ? 'h-5 w-5' : 'h-4 w-4'} style={{ color: 'currentColor' }} />
      {!isFocusMode && <span>{t('script_mode_active') || 'Script mode'}</span>}
    </button>
  );
};
